import useParaphraserEditor from '@chegg-wt/core-wa/hooks/useParaphraserEditor'
import { useSelector } from 'react-redux'
import { isPaperCheckInProgressSelector } from '@chegg-wt/core-wa/state/selectors'
import { useUpdateStateFromDB } from '@chegg-wt/core-wa/hooks/useUpdateStateFromDB'
import pusherManager from '@chegg-wt/core-wa/utils/pusherManager'
import { useOnEditorUpdate } from '@chegg-wt/core-wa/hooks/useOnEditorUpdate'
import { useEffect } from 'react'
import EditorFooter from '../EditorFooter/EditorFooter'
import EditorHeader from '../EditorHeader'
import EditorWrapper from '../EditorWrapper/EditorWrapper'
import { ProofReaderEditorContainer } from './styled'

const EditorContainer = ({ isRewritePanelActive }) => {
  const isPaperCheckInProgress = useSelector(isPaperCheckInProgressSelector)
  const editor = useParaphraserEditor({ disabled: isPaperCheckInProgress })

  useEffect(() => {
    pusherManager.initialize()
  }, [])

  useUpdateStateFromDB()
  useOnEditorUpdate()

  return (
    <ProofReaderEditorContainer isRewritePanelActive={isRewritePanelActive}>
      <EditorHeader editor={editor} />
      <EditorWrapper editor={editor} isPaperCheckInProgress={isPaperCheckInProgress} />
      <EditorFooter />
    </ProofReaderEditorContainer>
  )
}
export default EditorContainer
